import { API_URL, INITIAL_TOKEN } from "../config/config";
import { getAuthToken, logout } from "./auth";

async function request(url, options = {}) {
  const token = getAuthToken();

  // console.log(token);

  const headers = new Headers({
    Accept: "application/json",
    token: INITIAL_TOKEN,
    ...(options?.headers || {}),
  });

  if (!(options.body instanceof FormData)) {
    headers.set("Content-Type", "application/json");
  }

  if (token) {
    headers.append("authorization", `Bearer ${token}`);
  }

  try {
    const baseURL = options.baseURL || API_URL;
    const finalUrl = baseURL.endsWith("/") && url.startsWith("/")
      ? `${baseURL.slice(0, -1)}${url}`
      : `${baseURL}${url}`;

    const response = await fetch(finalUrl, {
      ...options,
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        logout();
        return Promise.reject(new Error("Session expired. Logging out."));
      }
      let errorData;
      try {
        errorData = await response.json();
      } catch (e) {
        errorData = { message: response.statusText };
      }

      const errorMessage = errorData?.message || "An error occurred";
      const error = new Error(errorMessage);
      error.response = response;
      error.data = errorData;
      throw error;
    }

    if (response.status === 204) {
      return;
    }

    return response.json();
  } catch (error) {
    console.error("API Client Error:", error);
    throw error;
  }
}

export const apiClient = {
  get: (url, options) => request(url, { ...options, method: "GET" }),
  post: (url, data, options) =>
    request(url, {
      ...options,
      method: "POST",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  put: (url, data, options) =>
    request(url, {
      ...options,
      method: "PUT",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  patch: (url, data, options) =>
    request(url, {
      ...options,
      method: "PATCH",
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  delete: (url, options) => request(url, { ...options, method: "DELETE" }),
};
